/* Product card Add to cart (snippets/pc-card.liquid). One delegated listener for every card on the page. */
(function () {
  if (window.pcCards) return; window.pcCards = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function closeAll(except, restoreFocus) {
    document.querySelectorAll('.pc-card.is-picking').forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-picking');
      c.querySelector('[data-pc-pick]').hidden = true;
      var b = c.querySelector('[data-pc-choose]');
      if (b) { b.setAttribute('aria-expanded', 'false'); if (restoreFocus) b.focus(); }
    });
  }

  function added(btn) {
    var label = btn.querySelector('span') || btn, old = label.textContent;
    btn.classList.add('is-done'); label.textContent = 'Added ✓';
    document.dispatchEvent(new CustomEvent('pc:added'));
    if (typeof window.CD_REFRESHCART === 'function' && typeof window.CD_OPENCART === 'function') {
      try { Promise.resolve(window.CD_REFRESHCART()).then(function () { window.CD_OPENCART(); }); } catch (e) {}
    } else { setTimeout(function () { location.href = root + 'cart'; }, 500); }
    setTimeout(function () { btn.classList.remove('is-done'); label.textContent = old; btn.disabled = false; closeAll(null, false); }, 1800);
  }

  document.addEventListener('click', function (e) {
    var choose = e.target.closest('[data-pc-choose]');
    if (choose) {
      var card = choose.closest('.pc-card'), pick = card.querySelector('[data-pc-pick]'), open = pick.hidden;
      closeAll(card, false); pick.hidden = !open; card.classList.toggle('is-picking', open); choose.setAttribute('aria-expanded', open);
      if (open) { var f = pick.querySelector('[data-pc-add]:not([disabled])'); if (f) f.focus(); }
      return;
    }
    if (e.target.closest('[data-pc-close]')) { closeAll(null, true); return; }
    var add = e.target.closest('[data-pc-add]');
    if (!add) { if (!e.target.closest('.pc-card__pick')) closeAll(null, false); return; }
    if (add.disabled) return;
    add.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +add.dataset.pcAdd, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { added(add); })
      .catch(function () { add.disabled = false; var c = add.closest('.pc-card'); var a = c && c.querySelector('.pc-card__link'); if (a) location.href = a.href; });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null, true); });
})();
